import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },
}));

class CheckboxesGroup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      checkArr:[],
      checked: this.props.checkedFalg
    };
  }


  componentDidUpdate(prevProps) {
    if(prevProps.checkedFalg != this.props.checkedFalg) {
      this.setState({checked: this.props.checkedFalg})
    }
  }

  handleCheck = (event, isInputChecked) => {
    this.setState({checked: isInputChecked})
  }

  render() {
    return (
      <FormControlLabel
        value={this.props.value}
        name={this.props.name}
        checked={this.state.checked}
        control={<Checkbox name={"checkbox-" + this.props.element.id} onChange={this.handleCheck}/>}
        //control={<Checkbox value={this.props.value} onChange={this.handleCheck} name={this.props.name} />}
        label={this.props.label} 
        
        />
    )
  }
}

export default CheckboxesGroup;
